const strings = {
    mainMenuLabels: { nav1: "settings "},
    navLabels: { nav1: "resume", nav2: "ai/nlp", nav3: "programming", nav4: "music" },
    searchLabels: { searchLabel: "search" },
    subNavLabels: { nav1: "list", nav2: "cards" },
    search: { "input": { "label": "search" }}
}

export default strings